var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
/**
 * In many cases, we need to have forms managed by react-hook-form inside other forms.  For example, a modal inside
 * a form.  This creates problems because forms are not allowed to be children of other forms.  This component serves as the
 * react-hook-form form element, but it can be used inside of other ReactHOokFormNestableForm elements.
 *
 * @returns a render props function which accepts a submit function, which when called will submit the form.
 */
const ReactHookFormNestableForm = (_a) => {
    var { children, inline } = _a, props = __rest(_a, ["children", "inline"]);
    const buttonRef = React.useRef(null);
    const submit = React.useCallback(() => { var _a; return (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, []);
    return (_jsxs(_Fragment, { children: [_jsx("form", Object.assign({}, props, { children: _jsx("button", { className: "d-none", type: "submit", ref: buttonRef }) })), inline ? (_jsx("div", { className: "form-inline sse-form-inline", children: children(submit) })) : (children(submit))] }));
};
export default ReactHookFormNestableForm;
